import http from "../http-common";

class ActivitiesService {
  create_activities(data) {
    return http.post(`/activities`, data);
  }
  getactivities() {
    return http.get(`/activities`);
  }
  getactivity(id) {
    return http.get('/activities/' + id);
  }
  update_days_of_week(id, data) {
    return http.put(`/activities/update_days_of_week/${id}`, data);
  }
  updateactivities(id, data) {
    return http.put(`/activities/${id}`, data);
  }
  deleteteacher(id) {
    return http.delete('/activities/' + id);
  }
}

export default new ActivitiesService();